import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: ${props => props.width}px;
  height: 25px;
  display: flex;
  position: relative;
  align-items: center;
`;
const MiddleBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: #c4c4c4;
  border-radius: 12px;
`;
const Circle = styled.div`
  width: 28px;
  height: 100%;
  left: ${props => props.position}px;
  border-radius: 50%;
  position: absolute;
  background-color: ${props => props.color};
  font-size: medium;
  font-weight: bold;
  text-align: center;
  line-height: 25px;
  color: ${props => props.fontColor || 'black'};
  transition: 1s;
`;

export default function Slider(props) {
  const { color, value, width = 200, fontColor } = props;

  function calculatePosition() {
    return (width / 100) * value - 18;
  }

  return (
    <Container width={width}>
      <MiddleBar />
      <Circle
        color={color}
        position={calculatePosition()}
        fontColor={fontColor}
      >
        {value}
      </Circle>
    </Container>
  );
}
